import { enableProdMode } from '@angular/core';
import '@angular/localize/init';
import { bootstrapApplication } from '@angular/platform-browser';
//import * as Sentry from '@sentry/angular';
import '@stripe/stripe-js';
import { environment } from 'shared/environments/environment';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// Sentry.init({
//   dsn: 'https://d1792ea170f407621625224de9df2bc6@o4509373182967808.ingest.us.sentry.io/4509373184802816',
//   sendDefaultPii: true,
//   environment: environment.production ? 'production' : 'development',
//   release: environment.appVersion,
// });

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
